export default __webpack_public_path__ + "static/media/left-ar.1b9cda8d.svg";